<template>
  <div class="combo-record">
    <div class="header">
      <div class="search-header">
        <el-select v-model="searchBuild" clearable placeholder="请选择楼盘">
          <el-option
            v-for="item in buildData"
            :key="item.building"
            :label="item.building"
            :value="item._id"
          ></el-option>
        </el-select>
        <el-select v-model="searchChannel" clearable placeholder="请选择渠道">
          <el-option v-for="item in channelsList" :key="item" :label="item" :value="item"></el-option>
        </el-select>
        <el-input v-model="searchKey" placeholder="请输入内容">
          <el-button slot="append" icon="el-icon-search" @click="toSearch"></el-button>
        </el-input>
      </div>
    </div>
    <div class="test-table">
      <div class="table-list" ref="tableL">
        <el-table
          v-loading="tableLoading"
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
        >
          <el-table-column label="序号" type="index" width="100"></el-table-column>
          <el-table-column label="用户名" prop="name"></el-table-column>
          <el-table-column label="电话" prop="phone"></el-table-column>
          <el-table-column label="权限" prop="roleName"></el-table-column>
          <el-table-column label="渠道权限" prop="targetChannels"></el-table-column>
          <el-table-column label="楼盘权限" prop="targetBuildings"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span
                v-if="scope.row.name === '管理员' || scope.row.phone === $store.state.userInfo.phone"
              >-</span>
              <el-button
                v-else
                size="mini"
                type="primary"
                style="margin-left: 5px"
                @click="editUser(scope.row)"
              >编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        class="pagination"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog
      title="用户信息"
      width="600px"
      :visible="visible"
      :before-close="()=>{visible = false}"
      :destroy-on-close="true"
    >
      <el-form
        label-width="180px"
        :model="editItem"
        :rules="rules"
        ref="ruleForm"
        class="rule-form"
      >
        <el-form-item label="用户名：">
          <span>{{editItem.name}}</span>
        </el-form-item>
        <el-form-item label="电话：">
          <span>{{editItem.phone}}</span>
        </el-form-item>
        <el-form-item label="权限：" prop="role" v-if="userRole === 'admin'">
          <el-select
            v-model="editItem.role"
            @change="roleChange"
            style="width: 220px;"
            placeholder="请选择"
          >
            <el-option
              v-for="item in filterList"
              :key="item.name"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="楼盘：" prop="target_buildings" v-if="editItem.role === 'agency'">
          <el-select
            v-model="editItem.target_buildings"
            multiple
            style="width: 220px;"
            placeholder="请选择"
          >
            <el-option
              v-for="item in buildData"
              :key="item.building"
              :label="item.building"
              :value="item._id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道：" prop="target_channels" v-if="editItem.role === 'agency'">
          <el-select
            v-model="editItem.target_channels"
            multiple
            style="width: 220px;"
            placeholder="请选择"
          >
            <el-option v-for="item in channelsList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="密码：" prop="user_password">
          <el-input v-model="editItem.user_password" placeholder="请输入内容" style="width: 220px;"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="()=>{visible = false}">取 消</el-button>
        <el-button type="primary" :loading="btnLoading" @click="submitForm()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Api from "@/api/api";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      tableHeight: 0,
      tableLoading: false,
      btnLoading: false,
      visible: false,
      searchKey: "",
      searchBuild: "",
      searchChannel: "",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      channelsList: [],
      buildData: [],
      editItem: {
        role: "",
        target_buildings: [],
        target_channels: [],
        user_password: ""
      },
      rules: {
        role: [{ required: false, message: "请选择权限", trigger: "change" }],
        target_buildings: [
          { required: false, message: "请选择楼盘", trigger: "change" }
        ],
        target_channels: [
          { required: false, message: "请选择渠道", trigger: "change" }
        ],
        user_password: [
          { required: false, message: "请输入密码", trigger: "blur" }
        ]
      },
      filterList: [
        {
          id: "admin",
          name: "管理员"
        },
        {
          id: "local_admin",
          name: "地区管理员"
        },
        {
          id: "agency",
          name: "普通用户"
        }
      ],
      paramsData: {
        phone: "",
        page: 1,
        page_size: 10
      },
      tableData: []
    };
  },
  computed: {
    ...mapGetters(["userRole"])
  },
  async mounted() {
    await this.getBuilding();
    await this.getChannelsList();
    await this.getList(this.paramsData);
    setTimeout(() => {
      this.tableHeight = this.$refs.tableL.offsetHeight;
    }, 500);
  },
  methods: {
    roleChange(vl) {
      console.log(vl);
      if (this.editItem.role === "agency") {
        this.editItem.target_channels = [];
        this.editItem.target_buildings = [];
      }
    },
    async getBuilding() {
      const { data } = await Api.buildList();
      this.buildData = data;
    },
    async getChannelsList() {
      const { data } = await Api.channelsList();
      this.channelsList = [...data];
    },
    async getList(params = this.paramsData) {
      this.tableLoading = true;
      const res = await Api.getUserList(params);
      this.tableData = res.data.page_data.map(val => {
        const data = val;
        data.roleName = this.filterList.find(
          item => item.id === data.role
        )?.name;
        const targetBuildings = data.target_buildings.map(val => {
          return this.buildData.find(item => item._id === val).building;
        });
        return {
          ...data,
          targetChannels: data.target_channels.join(",") || "-",
          targetBuildings: targetBuildings.join(",") || "-"
        };
      });
      this.total = res.data.total;
      this.tableLoading = false;
    },
    toSearch() {
      this.currentPage = 1;
      this.paramsData = {
        phone: this.searchKey,
        page: this.currentPage,
        page_size: this.pageSize
      };
      if (this.searchBuild) {
        this.paramsData.target_building = this.searchBuild;
      }
      if (this.searchChannel) {
        this.paramsData.target_channel = this.searchChannel;
      }
      if (this.state) {
        this.paramsData.state = this.state;
      }
      this.getList(this.paramsData);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.paramsData.page = val;
      this.getList(this.paramsData);
    },
    editUser(item) {
      this.editItem = JSON.parse(JSON.stringify(item));
      // this.editItem.user_password = "";
      this.visible = true;
    },
    submitForm() {
      if (this.editItem.role === "admin") {
        this.editItem.target_channels = this.channelsList;
        this.editItem.target_buildings = this.buildData.map(vl => vl._id);
      }
      // this.$refs["ruleForm"].validate(valid => {
      //   if (valid) {
      const {
        user_id,
        role,
        target_buildings,
        target_channels,
        user_password
      } = this.editItem;
      if (target_buildings.length > 0 && target_channels.length === 0) {
        this.$message({
          message: "请选择渠道",
          type: "warning"
        });
        return;
      }
      if (target_buildings.length === 0 && target_channels.length > 0) {
        this.$message({
          message: "请选择楼盘",
          type: "warning"
        });
        return;
      }
      if (target_buildings.length > 0 && !user_password) {
        this.$message({
          message: "请填写密码",
          type: "warning"
        });
        return;
      }
      const params = {
        modify_user_id: user_id,
        role,
        target_buildings,
        target_channels,
        user_password
      };
      this.btnLoading = true;
      Api.editUser(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: "保存成功",
            type: "success"
          });
          this.visible = false;
          this.getList(this.paramsData);
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
        this.btnLoading = false;
      });
      //   } else {
      //     return false;
      //   }
      // });
    }
  }
};
</script>
<style lang="scss" scoped>
.combo-record {
  position: relative;
  width: 100%;
  height: 100%;
  color: #333333;
  .header {
    .title {
      width: 150px;
      font-size: 1.2rem;
    }
    display: flex;
    height: 40px;
    line-height: 40px;
    justify-content: space-between;
  }
  .search-header {
    display: flex;
  }
  .test-table {
    width: 100%;
    height: calc(100% - 80px);
    margin-top: 20px;
    background: #ffffff;
    position: relative;
    border-radius: 6px;
    overflow: hidden;
  }
  .table-list {
    width: 100%;
    height: calc(100% - 50px);
    img {
      background: #dcdfe6;
      width: 50px;
      height: 50px;
      border-radius: 50%;
    }
    .table-expand {
      font-size: 0;
      padding: 0 100px;
    }
    .table-expand label {
      width: 90px;
      color: #99a9bf;
    }
    .table-expand .el-form-item {
      margin-right: 0;
      margin-bottom: 0;
      width: 100%;
    }
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
  }
  .user-info-item {
    display: flex;
    // cursor: pointer;
    // &:hover {
    //   color: rgb(96, 200, 224);
    // }
  }
}
</style>
